module.exports = __webpack_public_path__ + "img/restrooms-no.256c7396.svg";